import type { CSSProperties } from 'react'
import './Skeleton.css'

interface SkeletonLineProps {
    width?: string
    height?: string
    style?: CSSProperties
}

export function SkeletonLine({ width = '100%', height = '14px', style }: SkeletonLineProps) {
    return <div className="skeleton-line" style={{ width, height, ...style }} />
}

interface SkeletonBlockProps {
    lines?: number
    spacing?: number
}

export function SkeletonBlock({ lines = 4, spacing = 8 }: SkeletonBlockProps) {
    return (
        <div className="skeleton-block" style={{ gap: spacing }}>
            {Array.from({ length: lines }, (_, i) => (
                <SkeletonLine
                    key={i}
                    width={i === lines - 1 ? '60%' : `${85 + Math.random() * 15}%`}
                />
            ))}
        </div>
    )
}

export function SkeletonFileBrowser() {
    return (
        <div className="skeleton-filebrowser">
            <SkeletonLine width="50%" height="18px" style={{ marginBottom: 16 }} />
            {[1, 2, 3, 4, 5].map(i => (
                <div key={i} className="skeleton-file-row" style={{ paddingLeft: i > 2 ? 24 : 0 }}>
                    <SkeletonLine width="14px" height="14px" style={{ borderRadius: 2, flexShrink: 0 }} />
                    <SkeletonLine width={`${50 + Math.random() * 40}%`} height="14px" />
                </div>
            ))}
        </div>
    )
}

export function SkeletonEditor() {
    return (
        <div className="skeleton-editor">
            <div className="skeleton-editor-toolbar">
                <SkeletonLine width="120px" height="16px" />
                <div style={{ flex: 1 }} />
                <SkeletonLine width="60px" height="28px" style={{ borderRadius: 6 }} />
                <SkeletonLine width="60px" height="28px" style={{ borderRadius: 6 }} />
            </div>
            <div className="skeleton-editor-content">
                <SkeletonLine width="70%" height="22px" />
                <SkeletonLine width="100%" height="14px" />
                <SkeletonLine width="90%" height="14px" />
                <SkeletonLine width="95%" height="14px" />
                <SkeletonLine width="40%" height="14px" />
                <div style={{ height: 16 }} />
                <SkeletonLine width="50%" height="18px" />
                <SkeletonLine width="85%" height="14px" />
                <SkeletonLine width="75%" height="14px" />
                <SkeletonLine width="60%" height="14px" />
            </div>
        </div>
    )
}

export function SkeletonFullPage() {
    return (
        <div className="skeleton-fullpage">
            <div className="skeleton-topbar">
                <SkeletonLine width="140px" height="20px" />
                <SkeletonLine width="120px" height="16px" />
                <div style={{ flex: 1 }} />
                <div className="skeleton-actions">
                    {[1, 2, 3, 4].map(i => (
                        <SkeletonLine key={i} width="28px" height="28px" style={{ borderRadius: 6 }} />
                    ))}
                    <SkeletonLine width="28px" height="28px" style={{ borderRadius: '50%' }} />
                </div>
            </div>
            <div className="skeleton-body">
                <div className="skeleton-sidebar">
                    <SkeletonFileBrowser />
                </div>
                <div className="skeleton-main">
                    <SkeletonEditor />
                </div>
            </div>
        </div>
    )
}
